import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const subscriptionRouter: RouteConfig = {
  path: '/subscription',
  component: Layout,
  redirect: '/subscription/store-dashboard',
  name: 'Subscription',
  meta: {
    title: 'subscriptionSystem',
    icon: 'shopping'
  },
  children: [
    {
      path: 'store-dashboard',
      component: () => import('@/views/store-dashboard/index.vue'),
      name: 'StoreDashboard',
      meta: {
        title: 'storeDashboard',
        icon: 'dashboard',
        noCache: true
      }
    },
    {
      path: 'events',
      component: () => import('@/views/subscription-events/index.vue'),
      name: 'SubscriptionEvents',
      meta: {
        title: 'subscriptionEvents',
        icon: 'list',
        noCache: true
      }
    },
    {
      path: 'webhook-logs',
      component: () => import('@/views/webhook-logs/index.vue'),
      name: 'WebhookLogs',
      meta: {
        title: 'webhookLogs',
        icon: 'documentation',
        noCache: true
      }
    },
    {
      path: 'voice-assistant',
      component: () => import('@/views/voiceAssistant/index.vue'),
      name: 'VoiceAssistant',
      meta: {
        title: 'voiceAssistant',
        icon: 'service',
        noCache: true
      }
    }
  ]
}

export default subscriptionRouter
